export default class ExtensionOption {
  constructor(
  isSure,
  date,
  ) {
    this.isSure = isSure;
    this.date = date;
  }

  static createFromData(data) {
    if (data == null) return null;
    return new ExtensionOption(
      data.isSure,
      data.date,
    )
  }

  static createNew() {
    return new ExtensionOption(
      false,
      null,
    );
  }

}
